/**
 * An on/off control that saves as soon as it is flipped, so it carries its own label for the
 * accessibility tree and says On or Off beside the track. `busy` holds it while the save is in
 * flight; `disabled` is for a choice that cannot be made right now.
 */
export function Switch({ checked, onChange, label, disabled, busy }: {
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
  busy?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      aria-busy={busy || undefined}
      className={checked ? 'switch on' : 'switch'}
      disabled={disabled || busy}
      onClick={() => onChange(!checked)}
    >
      <span className="track"><span className="knob" /></span>
      <span className="text">{checked ? 'On' : 'Off'}</span>
    </button>
  );
}
